var Anhui = "آنهوي";
var Beijing = "بكين";
var Chongqing = "تشونغتشينغ";
var Fujian = "فوجيان";
var Gansu = "غانسو";
var Guangdong = "غوانغدونغ";
var Guangxi = "قوانغشى";
var Guizhou = "قويتشو";
var Hainan = "هاينان";
var Hebei = "هيبي";
var Heilongjiang = "هيلونغجيانغ";
var Henan = "هينان";
var Hubei = "هوبي";
var Hunan = "هونان";
var Jiangsu = "جيانغسو";
var Jiangxi = "جيانغشي";
var Jilin = "جيلين";
var Liaoning = "لياونينغ";
var Ningxia = "نينغشيا";
var Qinghai = "تشينغهاي";
var Shaanxi = "شانشي";
var Shandong = "شاندونغ";
var Shanghai = "شانغهاي";
var Shanxi = "شانشي";
var Sichuan = "سيتشوان";
var Tianjin = "تيانجين";
var Tibet = "التبت";
var Xinjiang = "شينجيانغ";
var Yunnan = "يونان";
var Zhejiang = "جيجيانغ";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "منغوليا الداخلية",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
